import React from 'react';
import { Helmet } from 'react-helmet-async';

const MovingTips = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <Helmet>
        <title>Moving Tips – MyMoveAdvisor</title>
        <meta name="description" content="Expert moving tips and advice to make your next move smooth, stress-free, and affordable. From packing to settling in." />
        <link rel="canonical" href="https://mymoveadvisor.com/moving-tips" />
        <meta property="og:title" content="Moving Tips – MyMoveAdvisor" />
        <meta property="og:description" content="Expert tips and advice to make your move smooth and stress-free." />
      </Helmet>
      <h1 className="text-3xl font-bold text-gray-800 mb-4">Moving Tips</h1>
      <p className="text-gray-600">Helpful advice to make your move smoother. (Placeholder)</p>
    </div>
  );
};

export default MovingTips;
